import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'
import { Swiper, SwiperSlide } from 'swiper/react'

import styles from './style.module.scss'

const cx = classnames.bind(styles)

type TimeItem = {
  label: string
  value: string
  isFuture?: boolean
}

type StartTimeTabProps = {
  timeList: {
    today: TimeItem[]
    tomorrow: TimeItem[]
  }
  selectedStartTime: string
  setSelectedStartTime: (time: string) => void
}

const StartTimeTab = (props: StartTimeTabProps) => {
  const { timeList, selectedStartTime, setSelectedStartTime } = props

  const { t } = useTranslation()

  const handleTabClick = (time: string) => {
    setSelectedStartTime(time)
  }

  const tomorrowTab = timeList?.tomorrow?.length > 0 ? timeList.tomorrow[0] : null

  return (
    <div className={cx('tabsContainer')}>
      <Swiper slidesPerView={'auto'} spaceBetween={10}>
        {timeList?.today.map((item) => {
          const isLive = !item.isFuture

          return (
            <SwiperSlide key={item.value}>
              <button className={cx('tab', { active: selectedStartTime === item.value })} onClick={() => handleTabClick(item.value)}>
                {`${item.label} ${isLive ? t('LiveDealsSection_StartTimeTab_Crazy_Suffix') : t('LiveDealsSection_StartTimeTab_Suffix')}`}
              </button>
            </SwiperSlide>
          )
        })}
        {tomorrowTab && (
          <SwiperSlide>
            <button className={cx('tab', { active: selectedStartTime === tomorrowTab.value })} onClick={() => handleTabClick(tomorrowTab.value)}>
              {`${tomorrowTab.label} ${t('LiveDealsSection_StartTimeTa_Tomorrow_Suffix')}`}
            </button>
          </SwiperSlide>
        )}
      </Swiper>
    </div>
  )
}

export default StartTimeTab
